module.exports = __webpack_public_path__ + "img/people.70f682da.png";